import { useCallback } from "react";

import { useJitsu } from "@jitsu/react";
import { ErrorKind, useErrorCallback } from "@/data/error/useError";
import { JitsuEvent } from "@/data/events/JitsuEvent";
import { useDeleteResourceMutation } from "@/generated/graphql";

/** Callback to delete an existing resource */
type OnDeleteResource = (id: string) => void;
type CallbackTuple = [OnDeleteResource, boolean];

export function useDeleteResource(): CallbackTuple {
  const { track } = useJitsu();
  const onError = useErrorCallback(ErrorKind.EditTask);
  const [mutate, { loading }] = useDeleteResourceMutation({
    ignoreResults: true,
    onError,
    onCompleted: (data) => {
      track(JitsuEvent.RESOURCE_DELETED, {
        resource_id: data.deleteResource.id,
      });
    },
  });
  const deleteResource = useCallback<OnDeleteResource>(
    (id) => {
      mutate({
        variables: { id },
        optimisticResponse: {
          deleteResource: {
            id,
            invalidated: true,
            __typename: "Resource",
          },
        },
      });
    },
    [mutate]
  );

  return [deleteResource, loading];
}
